import gql from 'graphql-tag';

export const ShareTargetFragment = gql`
  fragment shareTargetResults on Node {
    shareTargets {
      nodeId
      groupTargets(first: 200) {
        nodeId
        targets {
          ... on ShareTargetGroup {
            __typename
            id
            emoji
            groupName: name
          }
          nodeId
        }
        pageInfo {
          total
        }
      }
      orgPeopleTargets(first: 200) {
        nodeId
        targets {
          ... on Person {
            __typename
            id
            name
            avatarUrl
          }
          nodeId
          isOrgMember
        }
        pageInfo {
          total
        }
      }
      otherPeopleTargets(first: 200) {
        nodeId
        targets {
          ... on Person {
            __typename
            id
            name
            avatarUrl
          }
          nodeId
          isOrgMember
        }
        pageInfo {
          total
        }
      }
      __typename
    }
  }
`;

export const HasSharedWithFragment = gql`
  fragment hasSharedWith on Node {
    accessorInfo(includeGroups: $includeGroups) {
      accessors {
        ... on Group {
          id
          emoji
          groupName: name
        }
        ... on Person {
          id
          name
          email
          avatarUrl
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        total
      }
    }
  }
`;
